(function scrollLock() {
	this.position = 0;
	this.isLocked = false;
	let main = document.querySelector('.main-content');
	let body = document.body;

	document.documentElement.style.setProperty('--scroll-y', `0`);

	window.addEventListener('scroll', () => {
		if (this.isLocked) return;
		document.documentElement.style.setProperty('--scroll-y', `-${window.scrollY}px`);
	});

	window.addEventListener('lock', () => {
		this.isLocked = true;
		this.position = window.scrollY;
		body.classList.add('body--is-locked');
		main.style.transform = `translate(0, -${this.position}px)`;
	});

	window.addEventListener('unlock', () => {
		body.classList.remove('body--is-locked');
		main.style.transform = 'translate(0, 0)';
		window.scrollTo(0, parseInt(this.position) || 0);
		this.isLocked = false;
	});
})();